var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c("div", { staticStyle: { display: "flex", height: "590px" } }, [
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: { "label-width": "112px", disabled: _vm.readonly }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "MBL" } },
                    [
                      _c("el-input", {
                        attrs: { no: "1" },
                        model: {
                          value: _vm.form.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mbl", $$v)
                          },
                          expression: "form.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.MBLTransportationClause")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "freightTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.freightTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.freightTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.MasterBLFreightTerm") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentTermMBL",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentTermMBL = p.value
                            _vm.pm.paymentTermMBLChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PlaceOfMblPayment") } },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.pm.isShowAcPaymentPlaceBL,
                            expression: "!pm.isShowAcPaymentPlaceBL"
                          }
                        ],
                        attrs: {
                          no: "paymentPlaceBL",
                          disabled: !(
                            _vm.isEdit &&
                            (_vm.form.paymentTermMBL === "3P" ||
                              _vm.form.paymentTermMBL === "PP")
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.fieldChangeHandler()
                          }
                        },
                        model: {
                          value: _vm.mblDoc.paymentPlaceBL,
                          callback: function($$v) {
                            _vm.$set(_vm.mblDoc, "paymentPlaceBL", $$v)
                          },
                          expression: "mblDoc.paymentPlaceBL"
                        }
                      }),
                      _vm.pm.isShowAcPaymentPlaceBL
                        ? _c("cargo-advance-select", {
                            attrs: {
                              no: "paymentPlaceBL",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.mblDoc.paymentPlaceBL || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.mblDoc.paymentPlaceBL = p.value
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.form.containerLoadType === "FCL" ||
                  _vm.form.containerLoadType === "BB" ||
                  _vm.form.containerLoadType === "BCF" ||
                  _vm.form.containerLoadType === "BC"
                    ? _c("booking-sea-eq-data-grid", {
                        ref: "bookingSeaEqDataGrid",
                        attrs: {
                          no: "bookingSeaEqDataGrid",
                          value: _vm.seaEqList,
                          "is-edit": false,
                          "container-load-type": _vm.form.containerLoadType,
                          job: _vm.form
                        },
                        on: { eqQuantityChange: _vm.eqQuantityChangeHandler }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "350px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: {
                    "label-width": "112px",
                    "label-position": "right",
                    disabled: _vm.readonly
                  }
                },
                [
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          ref: "loadingPortCode",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "loadingPortCode",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.loadingPortCode,
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.loadingPortCodeChange(p)
                              _vm.pm.cargoDocChangeHandler()
                              _vm.pm.changeLoadingPort()
                              _vm.pm.setPlannerChange()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "padding-left": "2px" },
                            attrs: { no: "transfering" },
                            on: {
                              change: function($event) {
                                return _vm.pm.updateSecondVesselInfo()
                              }
                            },
                            model: {
                              value: _vm.form.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transfering", $$v)
                              },
                              expression: "form.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.transfering,
                          expression: "form.transfering"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.TransitPort") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.transferPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferPortCode = p.value
                            _vm.pm.updateSecondVesselInfo()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDischarge")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "dischargingPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.dischargingPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.dischargingPortCodeChange(
                              p.value,
                              _vm.form.carrierId
                            )
                            _vm.pm.cargoDocChangeHandler()
                            _vm.pm.changeDischargingPort()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.PlaceOfDelivery")))]
                      ),
                      _c("cargo-advance-select", {
                        staticClass: "port-of-delivery-selector",
                        attrs: {
                          no: "destinationPortCode",
                          "popper-class": "port-of-delivery-selector-popper",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.destinationPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.destinationPortCodeChange(p)
                            _vm.pm.cargoDocChangeHandler()
                            _vm.pm.changeDestinationPort()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_PlaceOfDeliveryRegion"))
                        )
                      ]),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "placeOfDeliveryRegion",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          filterable: "",
                          "default-value": _vm.form.placeOfDeliveryRegion
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.placeOfDeliveryRegion = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "departure-date-picker",
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            no: "etd",
                            value: _vm.form.etd,
                            "picker-options": {
                              disabledDate: _vm.disabledDate
                            },
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.etdChange }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            no: "eta",
                            "picker-options": {
                              disabledDate: _vm.disabledDate
                            },
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.etaChange },
                          model: {
                            value: _vm.form.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "eta", $$v)
                            },
                            expression: "form.eta"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "5",
                          "select-type": _vm.selectTypeNames.static_data_Vessel,
                          cache: false,
                          filterable: "",
                          "allow-create": _vm.eqPm._allowEditingVessel,
                          "default-value": _vm.form.vessel,
                          "static-options": _vm.eqPm.vesselList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.eqPm.onVesselSelectionChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                    [
                      _c("cargo-advance-select", {
                        ref: "voyageFlight",
                        attrs: {
                          no: "6",
                          "static-options": _vm.eqPm._voyages || [],
                          cache: false,
                          "default-value": _vm.form.voyageFlight,
                          filterable: "",
                          clearable: "",
                          "allow-create": _vm.eqPm.editVoyageMode === 1,
                          "tag-name": "voyageNo",
                          "tag-value": "voyageNo",
                          "filter-tag-names": ["voyageNo"]
                        },
                        on: {
                          focus: function($event) {
                            return _vm.eqPm.txtVoyageFocusInHandler()
                          },
                          parentCallBack: function(p) {
                            _vm.eqPm.onVoyageFlightChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ShippingCompanyContractNo")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "10" },
                        model: {
                          value: _vm.form.scNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "scNo", $$v)
                          },
                          expression: "form.scNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "CNPT No." } },
                    [
                      _c("cargo-repeat-value-select", {
                        attrs: {
                          placeholder: "",
                          no: "cNptNo",
                          filterable: "",
                          "allow-create": true,
                          clearable: "",
                          options: _vm.cNptList,
                          "label-field": "no",
                          "value-field": "no",
                          "unique-field": "no",
                          "match-of-repeat-value": _vm.matchOfCNpt
                        },
                        on: {
                          change: _vm.cNptChangeHandler,
                          handleBlur: _vm.cNptBlurHandler
                        },
                        model: {
                          value: _vm.form.cNptNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cNptNo", $$v)
                          },
                          expression: "form.cNptNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CarrierCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "carrierCode" },
                        model: {
                          value: _vm.form.carrierCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "carrierCode", $$v)
                          },
                          expression: "form.carrierCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.form.userDefinedRoleId1 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "332px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: {
                    "label-width": "112px",
                    "label-position": "right",
                    disabled: _vm.readonly
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.itemCount") } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "weightContract", precision: 3, min: 0 },
                        on: {
                          change: function($event) {
                            return _vm.pm.jobContractQwcChange(1)
                          }
                        },
                        model: {
                          value: _vm.form.quantityContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quantityContract", $$v)
                          },
                          expression: "form.quantityContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Weight") } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "weightContract", precision: 3, min: 0 },
                        on: {
                          change: function($event) {
                            return _vm.weightActualChange()
                          }
                        },
                        model: {
                          value: _vm.form.weightContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "weightContract", $$v)
                          },
                          expression: "form.weightContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Cubage") } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "92", precision: 3, min: 0 },
                        on: {
                          change: function($event) {
                            return _vm.cubageContractChange()
                          }
                        },
                        model: {
                          value: _vm.form.cubageContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cubageContract", $$v)
                          },
                          expression: "form.cubageContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "packing",
                          "default-value": _vm.form.packing
                        },
                        on: {
                          change: function(p) {
                            _vm.form.packing = p.value
                            _vm.pm.txtPackingChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck.cargoEnglishName
                          }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea1",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "cargoEnglishName",
                              "text-chars": _vm.englishNameMaxChars,
                              "warning-count": _vm.englishNameWarningCount,
                              "wrap-symbol": "r",
                              disabled: _vm.readonly,
                              "auto-uppercase": "",
                              "auto-half-word": ""
                            },
                            on: { change: _vm.onCargoEnglishNameChange },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                  _vm.mblDoc.cargoEnglishName,
                                  function(val) {
                                    _vm.mblDoc.cargoEnglishName = val
                                  },
                                  false,
                                  null,
                                  true,
                                  {
                                    warningCount: _vm.englishNameWarningCount,
                                    maxChar: _vm.englishNameMaxChars,
                                    autoUppercase: true,
                                    autoHalfWord: true
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.mblDoc.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.mblDoc, "cargoEnglishName", $$v)
                              },
                              expression: "mblDoc.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c(
                        "special-character-tip",
                        { attrs: { texts: _vm.specialCharCheck.mark } },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea2",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "mark",
                              "text-chars": _vm.markMaxChars,
                              "warning-count": _vm.markWarningCount,
                              "wrap-symbol": "r",
                              disabled: _vm.readonly,
                              "auto-uppercase": "",
                              "auto-half-word": ""
                            },
                            on: { change: _vm.onMarkChange },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.mblDoc.mark,
                                  function(val) {
                                    _vm.mblDoc.mark = val
                                  },
                                  false,
                                  null,
                                  true,
                                  {
                                    warningCount: _vm.markWarningCount,
                                    maxChar: _vm.markMaxChars,
                                    autoUppercase: true,
                                    autoHalfWord: true
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.mblDoc.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.mblDoc, "mark", $$v)
                              },
                              expression: "mblDoc.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { no: "hsCode", type: "textarea", rows: 5 },
                        on: {
                          input: function(val) {
                            _vm.mblDoc.hsCode = val
                          }
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.HsCode"),
                              _vm.mblDoc.hsCode,
                              function(val) {
                                _vm.mblDoc.hsCode = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.mblDoc.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.mblDoc, "hsCode", $$v)
                          },
                          expression: "mblDoc.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.bookingNotes") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks", type: "textarea", rows: 4 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.form.remarks,
                              function(val) {
                                _vm.form.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PortOfLoadingPOR") } },
                    [
                      _c("el-input", {
                        attrs: { no: "71" },
                        model: {
                          value: _vm.form.bargePOL,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargePOL", $$v)
                          },
                          expression: "form.bargePOL"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section", staticStyle: { width: "100%" } }, [
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "margin-top": "8px"
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    "label-width": "50px",
                    "label-position": "left",
                    disabled: _vm.readonly
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                    [
                      _c("el-input", {
                        ref: "shipperCode",
                        staticStyle: { width: "180px", "margin-right": "5px" },
                        attrs: { no: "16" },
                        model: {
                          value: _vm.mblDoc.shipperCode,
                          callback: function($$v) {
                            _vm.$set(_vm.mblDoc, "shipperCode", $$v)
                          },
                          expression: "mblDoc.shipperCode"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "24",
                            type: "primary",
                            disabled: _vm.readonly
                          },
                          on: {
                            click: function($event) {
                              return _vm.onClear(1)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(count) {
                    return _c(
                      "el-form-item",
                      {
                        key: "shipperLine" + count,
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["shipperLine" + count]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "shipperLine" + count,
                              refInFor: true,
                              attrs: {
                                no: "shipperLine" + count,
                                "auto-uppercase": _vm.isUppercase,
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.mblDoc,
                                    "shipperLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "shipperLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Shipper"),
                                    _vm.mergeShipperLine(),
                                    _vm.splitShipperLine,
                                    true,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase: true,
                                      maxChar: _vm.maxChars,
                                      warningCount: _vm.warningCount
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.mblDoc["shipperLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblDoc,
                                    "shipperLine" + count,
                                    $$v
                                  )
                                },
                                expression: "mblDoc['shipperLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: {
                    "label-width": "65px",
                    "label-position": "left",
                    disabled: _vm.readonly
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                    [
                      _c("el-input", {
                        ref: "consigneeCode",
                        staticStyle: { width: "180px", "margin-right": "5px" },
                        attrs: { disabled: _vm.readonly, no: "19" },
                        model: {
                          value: _vm.mblDoc.consigneeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.mblDoc, "consigneeCode", $$v)
                          },
                          expression: "mblDoc.consigneeCode"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "24",
                            type: "primary",
                            disabled: _vm.readonly
                          },
                          on: {
                            click: function($event) {
                              return _vm.onClear(2)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(count) {
                    return _c(
                      "el-form-item",
                      {
                        key: "consigneeLine" + count,
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts:
                                _vm.specialCharCheck["consigneeLine" + count]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "consigneeLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "consigneeLine" + count,
                                "auto-uppercase": _vm.isUppercase,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.mblDoc,
                                    "consigneeLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "consigneeLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Consignee"),
                                    _vm.mergeConsigneeLine(),
                                    _vm.splitConsigneeLine,
                                    true,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase: true,
                                      maxChar: _vm.maxChars,
                                      warningCount: _vm.warningCount
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.mblDoc["consigneeLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblDoc,
                                    "consigneeLine" + count,
                                    $$v
                                  )
                                },
                                expression: "mblDoc['consigneeLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: {
                    "label-width": "50px",
                    "label-position": "left",
                    disabled: _vm.readonly
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                    [
                      _c("el-input", {
                        ref: "notifyCode",
                        staticStyle: { width: "180px", "margin-right": "5px" },
                        attrs: { disabled: _vm.readonly, no: "22" },
                        model: {
                          value: _vm.mblDoc.notifyCode,
                          callback: function($$v) {
                            _vm.$set(_vm.mblDoc, "notifyCode", $$v)
                          },
                          expression: "mblDoc.notifyCode"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "24",
                            type: "primary",
                            disabled: _vm.readonly
                          },
                          on: {
                            click: function($event) {
                              return _vm.onClear(3)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(count) {
                    return _c(
                      "el-form-item",
                      {
                        key: "notifyLine" + count,
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c(
                          "special-character-tip",
                          {
                            attrs: {
                              texts: _vm.specialCharCheck["notifyLine" + count]
                            }
                          },
                          [
                            _c("cargo-input", {
                              ref: "notifyLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "notifyLine" + count,
                                "auto-uppercase": _vm.isUppercase,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.mblDoc,
                                    "notifyLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "notifyLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.NotifyParty"),
                                    _vm.mergeNotifyLine(),
                                    _vm.splitNotifyLine,
                                    true,
                                    {
                                      autoHalfWord: true,
                                      autoUppercase: true,
                                      maxChar: _vm.maxChars,
                                      warningCount: _vm.warningCount
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.mblDoc["notifyLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblDoc,
                                    "notifyLine" + count,
                                    $$v
                                  )
                                },
                                expression: "mblDoc['notifyLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section", staticStyle: { width: "100%" } }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MultiLegVoyageManagement")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: { "flex-direction": "row" }
            },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.leg.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "grid-style": "height:100%;",
                  "row-data": _vm.leg.rowData
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.leg.gridApi = params.api)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "append-to-body": "",
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readonly,
                      expression: "!readonly"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }